import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { DetailHeader } from '../properties/ui/detail-header';
import { usePropertyById, useUnitById } from '../../system/EntityManager';

/**
 * UnitsMain - parent component for all unit specific views
 * @returns JSX.Element: appropriate component based on route
 */

export function UnitsMain() {
  const { id: propertyId, unitId } = useParams<{
    id: string;
    unitId: string;
  }>();
  const property = usePropertyById(propertyId);
  const unit = useUnitById(unitId, propertyId);

  return property && unit ? (
    <>
      <DetailHeader property={property as any} unit={unit as any} />
      <Outlet />
    </>
  ) : null;
}
